'use client';
import { isEmpty, isObject } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { SWRConfiguration } from 'swr';
import { useClubSlug } from '.';
import { useApi } from '../../../hooks/useApi';

type Setting = any;
type UseSettingsReturn = [Setting, { isLoading: boolean }]; //SWRResponse<Setting, any>];

export const useSettings = (
    key: string,
    clubSlug?: string,
    swrOptions: SWRConfiguration<Setting, any> = {}
): UseSettingsReturn => {
    const api = useApi();
    const [_data, setData] = useState<Setting>();
    const [isLoading, setIsLoading] = useState(true);
    const dynamicClubSlug = useClubSlug(clubSlug);

    const fetchSettings = useCallback(() => {
        if (!dynamicClubSlug) {
            setIsLoading(false);
            return;
        }

        api({
            url: `club/${dynamicClubSlug}/settings/${key}`,
            method: 'GET',
            onSuccess: (data) => setData(data),
            onFinish: () => setIsLoading(false)
        });
    }, [dynamicClubSlug, key]);

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    // opt-in polling for long-lived screens (e.g. kiosk terminals) that would otherwise keep the
    // settings they loaded at mount forever; callers that pass no refreshInterval are unaffected
    // SWRConfiguration allows a function form; only a plain number makes sense for this simple poll
    const refreshInterval = typeof swrOptions.refreshInterval === 'number' ? swrOptions.refreshInterval : 0;
    useEffect(() => {
        if (!refreshInterval) return;
        const interval = setInterval(() => {
            if (!document.hidden) fetchSettings();
        }, refreshInterval);
        return () => clearInterval(interval);
    }, [refreshInterval, fetchSettings]);

    // const { data, isValidating, ...rest } = useSWR(`club/${dynamicClubSlug}/settings/${key}`, null, {
    //     refreshInterval: 0,
    //     revalidateIfStale: false,
    //     revalidateOnFocus: false,
    //     revalidateOnReconnect: false,
    //     ...swrOptions,
    // });
    // const isLoading = !data && isValidating;

    const data = isObject(_data) && isEmpty(_data) ? undefined : _data;

    return [
        data,
        {
            isLoading
        }
    ];
};
